import { GetServerSideProps } from 'next';
import React from 'react';

import { DefaultPage, RenderBlocks } from '@klappir/container/graphcms';
import { getPage } from '@klappir/data/graphcms';
import { DataGraphcms } from '@klappir/types';
import { SEO } from '@klappir/ui/core';

const Page = ({
  content,
  error404,
  params,
  preview,
}: DataGraphcms.PageProps) => {
  const canonical = content?.slug
    ? `https://www.klappir.com/${content.slug}`
    : undefined;
  return (
    <DefaultPage localizations={content.localizations}>
      {content?.seo && <SEO canonical={canonical} {...content.seo} />}
      <RenderBlocks blocks={content?.blocks ?? []} />
    </DefaultPage>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const slug = (context?.params?.slug as string[]).join('');
  const content = await getPage(slug || 'home', context.locale);

  if (!content) {
    return {
      notFound: true,
    };
  }

  return {
    props: { content: content || false },
  };
};

export default Page;
